import styled from '@emotion/styled'
import React from 'react'

import Tick from './Tick'
import Label from 'components/fields/Label'
import { formControlReset } from 'styles/reset'

const Wrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
`

const IconContainer = styled.label`
	overflow: hidden;
	margin-bottom: ${({ theme }) => theme.spaces.space3};
	cursor: pointer;
`

const HiddenInput = styled.input`
	${formControlReset};
	position: absolute;
	top: 0;
	left: 0;

	& + ${IconContainer} {
		& > svg {
			border: 2px solid transparent;
			border-radius: ${({ theme }) => theme.borderRadiuses.lg};
			width: fill-available;
		}
		& > span {
			visibility: hidden;
		}
	}

	&:checked + ${IconContainer} {
		& > svg {
			border: 2px solid ${({ theme }) => theme.colors.light.surfaceInteractive};
		}

		& > span {
			visibility: visible;
		}
	}

	&:focus-visible + ${IconContainer} {
		outline: 1px solid ${({ theme }) => theme.colors.light.accent};
		outline-offset: 2px;
	}
`

type Props = JSX.IntrinsicElements['input'] & {
	label: string
	icon: React.ReactNode
}

const IconRadio = React.forwardRef<HTMLInputElement, Props>(({ icon, label, ...inputProps }: Props, ref) => {
	const id = React.useId()
	return (
		<Wrapper>
			<HiddenInput id={id} type="radio" {...inputProps} ref={ref} />
			<IconContainer htmlFor={id}>
				{icon}
				<Tick />
			</IconContainer>
			<Label htmlFor={id} compact>
				{label}
			</Label>
		</Wrapper>
	)
})

IconRadio.displayName = 'IconRadio'

export default IconRadio
